/* eslint max-len: "off" */

const youreurope = (lang) =>
  `https://europa.eu/youreurope/citizens/consumers/shopping/guarantees-returns/index_${lang}.htm`;

const notices = {
  de: {
    title: 'Gesetzliche Gewährleistung',
    url: 'europa.eu/youreurope/garantien',
    href: youreurope('de'),
    summary:
      '<strong>Mindestens zwei Jahre gesetzliche Gewährleistung der Vertragsmäßigkeit</strong> für Waren, die in der Europäischen Union verkauft werden.',
    rights:
      'Verbraucherinnen und Verbraucher können ihre Rechte im Rahmen des gesetzlichen Gewährleistungsrechts geltend machen, z. B. wenn die Waren',
    rightsItems: ['nicht der Beschreibung entsprechen,', 'nicht bestimmungsgemäß funktionieren.'],
    liability:
      '<strong>Verkäufer haften</strong> für jede Vertragswidrigkeit, die zum Zeitpunkt der Lieferung der Waren bestand und innerhalb des Zeitraums der gesetzlichen Gewährleistung erkennbar wird. Verkäufer müssen in solchen Fällen Folgendes anbieten:',
    remedies: [
      '<strong>kostenlose Nachbesserung</strong> oder <strong>kostenlose Ersatzlieferung</strong>,',
      'in bestimmten Fällen eine <strong>Preisminderung</strong> oder eine <strong>vollständige Erstattung des Kaufpreises</strong>.',
    ],
    longer:
      'In einigen Ländern gilt ein längerer Zeitraum für die gesetzliche Gewährleistung. Für gebrauchte Waren kann ein kürzerer Zeitraum gelten, jedoch nicht weniger als ein Jahr.',
    moreInfo:
      'Für weitere Informationen zu Ihren Rechten in einem bestimmten Land scannen Sie den nachstehenden QR-Code oder fragen Sie den Verkäufer.',
    whatToDo: 'Was ist zu tun,',
    whatToDoSub: 'wenn Sie vertragswidrige Waren erhalten?',
    steps: [
      'Melden Sie dem Verkäufer das Problem so bald wie möglich.',
      'Legen Sie einen Kaufnachweis vor, z. B. die Quittung, Rechnung oder einen Kontoauszug.',
    ],
    garan:
      'Verkäufer und Hersteller können auch gewerbliche Garantien gewähren, die unabhängig von der gesetzlichen Gewährleistung gelten. Diese GARAN-Kennzeichnung zeigt beispielsweise, dass der Hersteller eine <strong>gewerbliche Haltbarkeitsgarantie</strong> ohne zusätzliche Kosten gewährt, die die gesamte Ware abdeckt.',
  },
  en: {
    title: 'Legal guarantee',
    url: 'europa.eu/youreurope/guarantees',
    href: 'https://europa.eu/youreurope/guarantees',
    summary:
      '<strong>Minimum two-year legal guarantee protection</strong> for goods sold in the European Union.',
    rights:
      'Consumers can claim their rights under the legal guarantee of conformity, for example if goods:',
    rightsItems: ['do not match the description;', 'do not function as intended.'],
    liability:
      '<strong>Sellers are liable</strong> for any lack of conformity which existed when the goods were delivered, and which becomes apparent within the legal guarantee period. Sellers in such a situation are required to offer:',
    remedies: [
      '<strong>free repair</strong> or <strong>free replacement;</strong>',
      'in some cases, a <strong>price reduction</strong> or <strong>full reimbursement</strong>.',
    ],
    longer:
      'Some countries have a longer legal guarantee period. For second-hand goods, a shorter period may apply, but not less than one year.',
    moreInfo:
      'For more information on your rights in a specific country, scan the QR code below or ask the seller.',
    whatToDo: 'What to do',
    whatToDoSub: 'if you receive non-conforming goods:',
    steps: [
      'Contact the seller as soon as possible to report the issue;',
      'Provide proof of purchase, such as a receipt, invoice, or bank statement.',
    ],
    garan:
      'Sellers and producers may also offer commercial guarantees, which apply independently from the legal guarantee. For example, you may see this GARAN label representing a <strong>commercial guarantee of durability</strong> offered by the producer at no additional cost and covering the entire good.',
  },
  fr: {
    title: 'Garantie légale',
    url: 'europa.eu/youreurope/garanties',
    href: youreurope('fr'),
    summary:
      '<strong>Protection offerte par la garantie légale minimale de deux ans</strong> sur des biens vendus dans l’Union européenne.',
    rights:
      'Les consommateurs peuvent faire valoir leurs droits au titre de la garantie légale de conformité, par exemple si les biens:',
    rightsItems: ['ne correspondent pas à la description;', 'ne fonctionnent pas comme prévu.'],
    liability:
      '<strong>Les vendeurs sont responsables</strong> de tout défaut de conformité qui existait au moment de la livraison des biens et qui apparaît pendant la période de garantie légale. Les vendeurs se trouvant dans une telle situation sont tenus de proposer:',
    remedies: [
      'une <strong>réparation gratuite</strong> ou un <strong>remplacement gratuit</strong>;',
      'dans certains cas, une <strong>réduction de prix</strong> ou un <strong>remboursement intégral</strong>.',
    ],
    longer:
      'Dans certains pays, la période de garantie légale est plus longue. Pour les biens d’occasion, une période plus courte peut s’appliquer, mais elle ne peut être inférieure à un an.',
    moreInfo:
      'Pour en savoir plus sur vos droits dans un pays donné, scannez le code QR ci-dessous ou consultez le vendeur.',
    whatToDo: 'Que faire',
    whatToDoSub: 'si vous recevez des biens non conformes:',
    steps: [
      'contactez le vendeur dès que possible pour signaler le problème;',
      'fournissez une preuve d’achat, telle qu’un reçu, une facture ou un relevé bancaire.',
    ],
    garan:
      'Les vendeurs et les producteurs peuvent également offrir des garanties commerciales, qui s’appliquent indépendamment de la garantie légale. Par exemple, il se peut que votre bien affiche ce label GARAN, représentant une <strong>garantie commerciale de durabilité</strong> offerte par le producteur sans frais supplémentaires et s’appliquant à l’ensemble du bien.',
  },
  it: {
    title: 'Garanzia legale',
    url: 'europa.eu/youreurope/garanzie',
    href: youreurope('it'),
    summary:
      '<strong>Garanzia legale minima di due anni</strong> per i beni venduti nell’Unione europea.',
    rights:
      'I consumatori possono far valere i loro diritti nell’ambito della garanzia legale di conformità, ad esempio se i beni:',
    rightsItems: ['non corrispondono alla descrizione;', 'non funzionano come previsto.'],
    liability:
      '<strong>I venditori sono responsabili</strong> di qualsiasi difetto di conformità esistente al momento della consegna dei beni e che si manifesta entro il periodo della garanzia legale. In tal caso i venditori sono tenuti a offrire:',
    remedies: [
      'la <strong>riparazione</strong> o <strong>sostituzione gratuita</strong>;',
      'in alcuni casi, una <strong>riduzione del prezzo</strong> o il <strong>rimborso integrale</strong>.',
    ],
    longer:
      'Alcuni paesi prevedono un periodo di garanzia legale più lungo. Per i beni di seconda mano può valere un periodo più breve, ma non inferiore a un anno.',
    moreInfo:
      'Per saperne di più sui propri diritti in un determinato paese, scansionare il codice QR qui sotto o chiedere informazioni al venditore.',
    whatToDo: 'Cosa fare',
    whatToDoSub: 'se si ricevono beni non conformi:',
    steps: [
      'contattare quanto prima il venditore per segnalare il problema;',
      'fornire la prova dell’acquisto, ad esempio una ricevuta, una fattura o un estratto conto bancario.',
    ],
    garan:
      'I venditori e i produttori possono anche offrire garanzie commerciali, che si applicano indipendentemente dalla garanzia legale. Ad esempio, questa etichetta GARAN rappresenta una <strong>garanzia commerciale di durabilità</strong> offerta dal produttore senza costi aggiuntivi, che copre il bene nel suo complesso.',
  },
  nl: {
    title: 'Wettelijke garantie',
    url: 'europa.eu/youreurope/garantie',
    href: youreurope('nl'),
    summary:
      '<strong>Minimaal twee jaar bescherming dankzij de wettelijke garantie</strong> voor goederen die in de Europese Unie worden verkocht.',
    rights:
      'Consumenten kunnen hun rechten doen gelden op grond van de wettelijke conformiteitsgarantie, bijvoorbeeld als goederen:',
    rightsItems: ['niet met de beschrijving overeenstemmen;', 'niet naar behoren functioneren.'],
    liability:
      '<strong>Verkopers zijn aansprakelijk</strong> voor elk conformiteitsgebrek dat bestond bij de levering van de goederen en dat binnen de wettelijke garantieperiode aan het licht komt. Verkopers moeten in een dergelijke situatie het volgende aanbieden:',
    remedies: [
      '<strong>gratis reparatie</strong> of <strong>gratis vervanging;</strong>',
      'in sommige gevallen, <strong>gedeeltelijke</strong> of <strong>volledige terugbetaling</strong>.',
    ],
    longer:
      'Sommige landen hebben een langere wettelijke garantieperiode. Voor tweedehandsartikelen kan de garantieperiode korter zijn, maar niet korter dan één jaar.',
    moreInfo:
      'Als u meer wilt weten over uw rechten in een bepaald land, kunt u de QR-code hieronder scannen of de verkoper om informatie vragen.',
    whatToDo: 'Wat moet u doen',
    whatToDoSub: 'als u niet-conforme goederen ontvangt:',
    steps: [
      'Neem zo spoedig mogelijk contact op met de verkoper om het probleem te melden.',
      'Verstrek een aankoopbewijs, zoals een bon, een factuur of een rekeningafschrift.',
    ],
    garan:
      'Verkopers en producenten kunnen ook commerciële garanties aanbieden, die los van de wettelijke garantie van toepassing zijn. Dit GARAN-label bijvoorbeeld staat voor een <strong>commerciële levensduurgarantie</strong> die kosteloos door de producent wordt aangeboden en het volledige goed dekt.',
  },
  es: {
    title: 'Garantía legal',
    url: 'europa.eu/youreurope/garantías',
    href: youreurope('es'),
    summary:
      '<strong>Garantía legal mínima de dos años</strong> para los bienes vendidos en la Unión Europea.',
    rights:
      'Los consumidores pueden hacer valer los derechos que les otorga la garantía legal de conformidad, por ejemplo, si los bienes:',
    rightsItems: ['no coinciden con la descripción;', 'no funcionan según lo previsto.'],
    liability:
      '<strong>Los vendedores son responsables</strong> de cualquier falta de conformidad que existiera en el momento de la entrega de los bienes y que se ponga de manifiesto dentro del período de garantía legal. Los vendedores que se encuentren en tal situación están obligados a ofrecer:',
    remedies: [
      'la <strong>reparación</strong> o <strong>sustitución gratuitas</strong>;',
      'en algunos casos, una <strong>reducción del precio</strong> o un <strong>reembolso total</strong>.',
    ],
    longer:
      'Algunos países tienen un período de garantía legal más largo. En el caso de los bienes de segunda mano, dicho período puede ser más corto, pero nunca inferior a un año.',
    moreInfo:
      'Para obtener más información sobre sus derechos en un país específico, escanee el código QR que figura a continuación o consulte al vendedor.',
    whatToDo: 'Qué hacer',
    whatToDoSub: 'si recibe bienes no conformes:',
    steps: [
      'Póngase en contacto con el vendedor lo antes posible para notificar el problema.',
      'Aporte pruebas de la compra, como un recibo, una factura o un extracto bancario.',
    ],
    garan:
      'Los vendedores y los productores también pueden ofrecer garantías comerciales, que se aplican independientemente de la garantía legal. Por ejemplo, la etiqueta GARAN representa una <strong>garantía comercial de durabilidad</strong> ofrecida por el productor sin coste adicional y que cubre la totalidad del bien.',
  },
  da: {
    title: 'Retlig garanti',
    url: 'europa.eu/youreurope/garantier',
    href: youreurope('da'),
    summary:
      '<strong>Retlig garanti på mindst to år</strong> for varer, der sælges i Den Europæiske Union.',
    rights:
      'Forbrugere kan gøre deres rettigheder gældende under henvisning til den retlige garanti for kontraktmæssighed, f.eks. hvis varer:',
    rightsItems: ['ikke svarer til beskrivelsen', 'ikke fungerer efter hensigten.'],
    liability:
      '<strong>Sælgerne er ansvarlige</strong> for enhver mangel, der eksisterede på det tidspunkt, hvor varerne blev leveret, og som viser sig inden for den retlige garantiperiode. Sælgere skal i en sådan situation tilbyde:',
    remedies: [
      '<strong>gratis reparation</strong> eller <strong>gratis omlevering</strong>',
      'i nogle tilfælde et <strong>forholdsmæssigt afslag i prisen</strong> eller <strong>fuld tilbagebetaling</strong>.',
    ],
    longer:
      'Nogle lande har en længere retlig garantiperiode. For brugte varer kan der gælde en kortere periode, dog mindst et år.',
    moreInfo:
      'Hvis du vil vide mere om dine rettigheder i et bestemt land, kan du scanne QR-koden nedenfor eller spørge sælgeren.',
    whatToDo: 'Hvad skal du gøre,',
    whatToDoSub: 'hvis du modtager mangelfulde varer:',
    steps: [
      'Kontakt sælgeren så hurtigt som muligt for at gøre opmærksom på problemet',
      'Fremlæg bevis for købet, f.eks. i form af en kvittering, en faktura eller et kontoudtog.',
    ],
    garan:
      'Sælgere og producenter kan også tilbyde handelsmæssige garantier, som gælder uafhængigt af den retlige garanti. For eksempel kan du se dette GARAN-mærke, der giver en <strong>handelsmæssig garanti for holdbarhed</strong>, som producenten tilbyder uden yderligere omkostninger, og som omfatter hele varen.',
  },
  sv: {
    title: 'Reklamationsrätt',
    url: 'europa.eu/youreurope/reklamationsrätt',
    href: youreurope('sv'),
    summary: 'Du har <strong>minst två års reklamationsrätt</strong> för en vara du köpt i EU.',
    rights: 'Som konsument har du rätt att reklamera en vara om den till exempel',
    rightsItems: ['inte motsvarar beskrivningen', 'inte fungerar som avsett.'],
    liability:
      '<strong>Säljaren är ansvarig</strong> för brister som fanns när varan levererades och som upptäcks inom den period som reklamationsrätten gäller. Säljaren måste i så fall erbjuda',
    remedies: [
      '<strong>gratis reparation</strong> eller <strong>gratis byte av varan</strong>',
      'i vissa fall <strong>prisavdrag</strong> eller <strong>alla pengarna tillbaka</strong>.',
    ],
    longer:
      'I vissa länder kan reklamationsrätten vara längre än två år. För begagnade varor kan den vara kortare, men aldrig kortare än ett år.',
    moreInfo:
      'För mer information om dina rättigheter i ett visst land kan du skanna qr-koden nedan eller fråga säljaren.',
    whatToDo: 'Vad du ska göra',
    whatToDoSub: 'om en vara är bristfällig',
    steps: [
      'Kontakta säljaren så snart som möjligt och rapportera problemet.',
      'Visa upp bevis på köpet, till exempel kvitto, faktura eller kontoutdrag.',
    ],
    garan:
      'Säljarna och tillverkarna kan ibland erbjuda kommersiella garantier som gäller oberoende av reklamationsrätten. Du kan till exempel se den här GARAN-märkningen för <strong>hållbarhetsgarantier</strong> som tillverkaren erbjuder utan kostnad och som omfattar hela varan.',
  },
  pl: {
    title: 'Prawny obowiązek zapewnienia zgodności towaru z umową',
    url: 'europa.eu/youreurope/gwarancje',
    href: youreurope('pl'),
    summary:
      'Towary sprzedawane w Unii Europejskiej objęte są prawnym obowiązkiem zapewnienia ich zgodności z umową <strong>przez okres co najmniej dwóch lat</strong>.',
    rights:
      'Konsumenci mogą dochodzić swoich praw na podstawie tego prawnego obowiązku zapewnienia zgodności towaru z umową, na przykład jeżeli towar:',
    rightsItems: ['jest niezgodny z opisem', 'funkcjonuje niezgodnie z przeznaczeniem.'],
    liability:
      '<strong>Sprzedawcy odpowiadają</strong> za wszelkie niezgodności towaru z umową, które istnieją w momencie dostawy towaru i które ujawnią się w czasie trwania prawnego obowiązku zapewnienia zgodności z umową. W takiej sytuacji sprzedawcy są zobowiązani zaoferować:',
    remedies: [
      '<strong>bezpłatną naprawę</strong> lub <strong>bezpłatną wymianę towaru</strong>',
      'w niektórych przypadkach <strong>obniżenie ceny</strong> lub <strong>jej całkowity zwrot.</strong>',
    ],
    longer:
      'W niektórych krajach obowiązuje dłuższy okres prawnego obowiązku zapewnienia zgodności towaru z umową. Krótszy okres może obowiązywać w przypadku towarów używanych, jednak nie może on być krótszy niż rok.',
    moreInfo:
      'Aby uzyskać więcej informacji na temat przysługujących Ci praw w danym kraju, zeskanuj poniższy kod QR lub zwróć się do sprzedawcy.',
    whatToDo: 'Co zrobić,',
    whatToDoSub: 'jeżeli otrzymany towar jest niezgodny z umową?',
    steps: [
      'Jak najszybciej skontaktuj się ze sprzedawcą, by zgłosić ewentualny problem.',
      'Przedstaw dowód potwierdzający zakup, taki jak pokwitowanie, faktura lub wyciąg bankowy.',
    ],
    garan:
      'Sprzedawcy i producenci mogą również oferować gwarancje handlowe, które są stosowane niezależnie od prawnego obowiązku zapewnienia zgodności towaru z umową. Na przykład etykieta GARAN oznacza <strong>handlową gwarancję trwałości</strong>, którą producent oferuje bez dodatkowych kosztów na cały towar.',
  },
};

export const noticeLanguages = Object.keys(notices);

export const showsLegalGuarantee = (currency) => currency !== 'CHF';

export default function legalGuaranteeNotice(language) {
  return notices[language] || notices.en;
}
